import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { toast } from 'react-toastify'
import { IOperationLiveTaskResponse } from 'types/api/operationsAimApi.interface'
import { ICreateManualTaskRequest } from 'types/api/operationsManualTaskApi.interface'
import { IOpsLiveTasksSlice } from 'types/opsLiveTasks.interface'
import { baseUrl } from 'utils/axios'
import { handleErrors } from 'utils/helpers'
import { mapLiveTask } from 'pages/Operations/Shared/opsApiMappers'
import { USE_OPS_MOCKS } from 'pages/Operations/Shared/opsControl'
import { DEMO_LIVE_TASKS } from 'pages/Operations/Shared/opsApiDemoCore'

const initialState: IOpsLiveTasksSlice = {
  isLoading: false,
  tasks: [],
}

export const getLiveTasks = createAsyncThunk(
  'opsLiveTasks/getLiveTasks',
  async (params: any, thunkAPI) => {
    if (USE_OPS_MOCKS) return DEMO_LIVE_TASKS
    try {
      const resp: AxiosResponse<IOperationLiveTaskResponse[]> = await baseUrl.get(
        'aim-operations/tasks/live',
        { params },
      )
      return resp.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
)

export const createManualTask = createAsyncThunk(
  'opsLiveTasks/createManualTask',
  async (payload: ICreateManualTaskRequest, thunkAPI) => {
    try {
      const resp: AxiosResponse = await baseUrl.post('task/generate', {
        taskTemplateId: payload.taskTemplateId,
        locationNodeId: payload.locationNodeId,
        criteria: payload.criteria ?? 1,
        componentValues: [],
        toolComponentValues: payload.toolComponentValues ?? [],
        startDate: payload.startDate,
        isTriggered: false,
      })
      return resp.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
)

const opsLiveTasksSlice = createSlice({
  name: 'opsLiveTasks',
  initialState,
  reducers: {
    clearLiveTasks: (state) => {
      state.tasks = []
    },
  },
  extraReducers: {
    [getLiveTasks.pending.type]: (state) => {
      state.isLoading = true
    },
    [getLiveTasks.fulfilled.type]: (state, { payload }: { payload: IOperationLiveTaskResponse[] }) => {
      state.isLoading = false
      state.tasks = (payload || []).map(mapLiveTask)
    },
    [getLiveTasks.rejected.type]: (state, action) => {
      state.isLoading = false
      handleErrors(action.payload)
    },
    [createManualTask.pending.type]: (state) => {
      state.isLoading = true
    },
    [createManualTask.fulfilled.type]: (state) => {
      state.isLoading = false
      toast.success('Task created successfully')
    },
    [createManualTask.rejected.type]: (state, action) => {
      state.isLoading = false
      handleErrors(action.payload)
    },
  },
})

export const { clearLiveTasks } = opsLiveTasksSlice.actions
export default opsLiveTasksSlice.reducer
